import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import searchFill from "@iconify/icons-eva/search-fill";
import inboxOutline from "@iconify/icons-eva/inbox-outline";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  CardContent,
  TableContainer,
  TablePagination,
  Container,
  InputAdornment,
  Box,
  OutlinedInput,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Page from "../../../../components/Page";
import ReportListToolbar from "../../../customer/components/ReportListToolbar";
import Scrollbar from "../../../../components/Scrollbar";
import OrdersListHead from "../../../customer/components/OrdersListHead";
import orderService from "../../../customer/services/orderService";
import SearchNotFound from "../../../../components/SearchNotFound";
import AlertMessage from "../../../../components/alert/alert";
import { styled } from "@mui/system";
import financialService from "../services/financialService";
import { useSearchParams } from "react-router-dom";

const TABLE_HEAD = [
  { id: "created_at", label: "Data", alignRight: false },
  { id: "id_Order", label: "O.S", alignRight: false },
  { id: "description", label: "Descrição", alignRight: false },
  { id: "Tipo lente", label: "Status", alignRight: false },
  { id: "Tipo lente2", label: "Tipo lente", alignRight: false },
  { id: "amount", label: "Qtde (Pares)", alignRight: false },
  { id: "valueWithDiscount", label: "Valor", alignRight: false },
];

const StageNAME: any = {
  1: "BAIXA",

  2: "LENSOMETRO",

  3: "PERDA",

  4: "RETRABALHO",

  5: "VERIFICACAO VISUAL",

  6: "REPROVADA NO RECEBIMENTO",

  7: "CANCELADA",

  8: "CONTINUAR PROCESSO",

  9: "ENVIADA",
  CADASTRADA: "Cadastrada",
  RECEBIDA: "Recebida",
};

const SearchStyle = styled(OutlinedInput)(({ theme }: any) => ({
  height: 48,
  float: "left",
  borderRadius: "40px",
  backgroundColor: "#fff",
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

function nameStageCalculator(data: any) {
  if (data.name_Stage) {
    return StageNAME[data.name_Stage];
  }
  if (!data.receivementDate_Order) {
    return "Cadastrada";
  }

  return "Recebida";
}
function descendingComparator(a: any, b: any, orderBy: any) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array: any, comparator: any, query: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (query.includes("-")) {
      if (query.includes(" ")) {
        const stringDates = query?.split(" ");
        const dates = [new Date(stringDates[0]), new Date(stringDates[1])];
        dates[0].setHours(0);
        dates[1].setHours(0);

        return filter(array, (_report) => {
          const dateData = _report.date?.split("/");
          const arrDate = new Date(
            `${dateData[2]}-${dateData[1]}-${dateData[0]}`
          );
          arrDate.setHours(0);

          return arrDate <= dates[1] && arrDate >= dates[0];
        });
      } else {
        let greaterThan: boolean = false;
        if (query.includes("&")) {
          greaterThan = true;
          query.replace("&", "");
        }

        const date = new Date(query);
        date.setHours(0);

        return filter(array, (_report) => {
          const dateData = _report.date?.split("/");
          const arrDate = new Date(
            `${dateData[2]}-${dateData[1]}-${dateData[0]}`
          );
          arrDate.setHours(0);

          // if (!greaterThan) arrDate.setDate(arrDate.getDate() + 1);
          return greaterThan ? date > arrDate : date <= arrDate;
        });
      }
    } else {
      return filter(
        array,
        (_report) =>
          _report.id_Order
            ?.toLocaleString("pt-br", {
              minimumIntegerDigits: 5,
              useGrouping: false,
            })
            .toString()
            .indexOf(query) !== -1
      );
    }
  }
  return stabilizedThis.map((el: any) => el[0]);
}

export default function ReportAdmin() {
  const parse: any = localStorage.getItem("user");
  const user = JSON.parse(parse);
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(0);
  const [data, setData]: any = useState([]);
  const [order, setOrder] = useState("asc");
  const [password, setPassword] = useState("");
  const [showError, setError] = useState(false);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [passwordModal, setPasswordModal] = useState(false);
  const [paginationData, setPaginationData]: any = useState({});
  const [refresh, setRefresh] = useState(false);
  const [dataSelect, setDataSelect]: any = useState("0");
  const [dataFilial, setDataFilial]: any = useState("0");
  const [dataFilter, setDataFilter]: any = useState([]);
  const [sumData, setSumData]: any = useState({});

  const code = searchParams.get("id");

  useEffect(() => {
    setOrder("asc");
    setOrderBy("name");
  }, []);

  useEffect(() => {
    const query = code && filterName === "" ? code : filterName;
    orderService
      .getReportADM(page, rowsPerPage, query, dataSelect, dataFilial)
      .then((data: any) => {
        setData(data.data?.result);
        setSumData(data.data?.sum);
        setPaginationData(data.data?.pagination);
        setPasswordModal(false);
      })
      .catch((error: any) => {
        setError(true);
        setPassword("");
        console.error(error);
      });
    if (code && filterName === "") {
      setFilterName(code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, refresh, dataSelect, code]);

  useEffect(() => {
    if (showError) setTimeout(() => setError(false), 2000);
  }, [showError]);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  useEffect(() => {
    financialService
      .getAll("0", "50", {
        startDate: undefined,
        endDate: undefined,
      })
      .then((data: any) => setDataFilter(data.data))
      .catch((error: any) => console.error(error));
  }, []);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const handleChangeBilling = (event: any) => {
    setDataSelect(event.target.value);
  };

  const handleDataFilial = (event: any) => {
    setDataFilial(event.target.value);
  };
  const isUserNotFound = false;

  return (
    <>
      <Page title="Relatório | Optools">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h4" gutterBottom>
              Relatório
            </Typography>
          </Stack>
          <Stack
            direction={["column", "row"]}
            justifyContent="flex-start"
            py={2}
          >
            <SearchStyle
              sx={{
                width: ["100%", 256],
                mr: 2,
              }}
              type="text"
              value={filterName}
              placeholder="Pesquisar..."
              inputProps={{ style: { textTransform: "uppercase" } }}
              onChange={(element: any) => setFilterName(element.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <Box
                    component={Icon}
                    icon={searchFill}
                    sx={{ color: "text.disabled" }}
                  />
                </InputAdornment>
              }
            />
            <FormControl sx={{ pr: 2, minWidth: 380 }}>
              <InputLabel id="demo-select-small-label">
                Data de fechamento
              </InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={dataSelect}
                label="Escolha o fechamento"
                onChange={handleChangeBilling}
              >
                <MenuItem value={"0"}>Ordens em aberto</MenuItem>
                {dataFilter.map((item: any, index: any) => (
                  <MenuItem value={item.id_Billing} key={index}>
                    Fechamento {item.id_Billing} -{" "}
                    {item.serverRegisterDate_Billing}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ pr: 2, minWidth: 150 }}>
              <InputLabel id="demo-select-small-label">Filial</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={dataFilial}
                label="Escolha o fechamento"
                onChange={handleDataFilial}
              >
                <MenuItem value={"0"}>Todas</MenuItem>
                <MenuItem value={"PA"}>PA - Porto Alegre</MenuItem>
                <MenuItem value={"NE"}>NE - Fortaleza</MenuItem>
                <MenuItem value={"SP"}>SP - São Paulo</MenuItem>
              </Select>
            </FormControl>

            <Button
              sx={{
                height: "48px",
                borderRadius: "40px",

                background: "#004A78",

                marginBottom: ["24px", 0],
                "&:hover": {
                  backgroundColor: "#226C9A",
                },
              }}
              onClick={() => {
                searchParams.delete("id");
                setPage(0);
                setRefresh(!refresh);
              }}
              color="secondary"
              variant="contained"
            >
              Pesquisar
            </Button>
          </Stack>
          <Card>
            <CardContent sx={{ paddingTop: [0, "auto"] }}>
              <Scrollbar>
                <TableContainer>
                  <Table>
                    <OrdersListHead headLabel={TABLE_HEAD} />
                    <TableBody>
                      {data.length > 0 ? (
                        data.map((row: any, index: number) => {
                          const {
                            created_at,
                            lensesAmount_Order,
                            name_Lens,
                            valueWithDiscount,
                            code_Order,
                            value_ServiceOrder,
                            balance,
                            idDesign_Order,
                            name_Stage,
                          } = row;
                          if (created_at)
                            return (
                              <TableRow
                                hover
                                key={index}
                                tabIndex={-1}
                                role="checkbox"
                                selected={false}
                                aria-checked={false}
                              >
                                <TableCell component="th" scope="row">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {created_at}
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {code_Order}
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {name_Lens}
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {nameStageCalculator(row)}
                                  </Typography>
                                </TableCell>

                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {idDesign_Order === 3
                                      ? "Normal"
                                      : "Recortada"}
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {lensesAmount_Order / 2}
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography
                                    variant="subtitle2"
                                    noWrap
                                    sx={{
                                      color: "#004A78",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {valueWithDiscount !== "R$ 0,00"
                                      ? valueWithDiscount
                                      : value_ServiceOrder}
                                  </Typography>
                                </TableCell>

                                {user.prepaid ? (
                                  <TableCell align="left">
                                    <Typography
                                      variant="subtitle2"
                                      noWrap
                                      sx={{
                                        color: "#004A78",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {balance}
                                    </Typography>
                                  </TableCell>
                                ) : undefined}
                              </TableRow>
                            );
                          else return undefined;
                        })
                      ) : (
                        <>
                          <TableRow>
                            <TableCell
                              align="center"
                              colSpan={6}
                              sx={{ py: 3 }}
                            >
                              <Stack
                                width="100%"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <Icon
                                  icon={inboxOutline}
                                  width="56px"
                                  color="#909090"
                                />
                                <Typography
                                  mt={1}
                                  variant="body1"
                                  noWrap
                                  sx={{ color: "#909090" }}
                                >
                                  Nenhum item encontrado...
                                </Typography>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        </>
                      )}

                      <TableRow sx={{ backgroundColor: "#004A78" }}>
                        <TableCell colSpan={7} sx={{ pr: 10 }}>
                          <Stack
                            flexDirection="row"
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Typography
                              variant="body1"
                              noWrap
                              sx={{ color: "#FFF" }}
                            >
                              Valor Total
                            </Typography>
                            <Typography
                              variant="body1"
                              noWrap
                              sx={{ color: "#FFF", fontWeight: "bold" }}
                            >
                              {sumData.sumDiscount === "R$ 0,00"
                                ? sumData.sumTotal
                                : sumData.sumDiscount}
                            </Typography>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    {isUserNotFound && data.length ? (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : undefined}
                  </Table>
                </TableContainer>

                <TablePagination
                  page={page}
                  component="div"
                  count={paginationData.totalRecords}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage}
                  rowsPerPageOptions={[10, 20, 50, 100, 200]}
                  labelRowsPerPage="Linhas por página:"
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelDisplayedRows={(rowsInfo) => {
                    const totalPages = Math.ceil(
                      rowsInfo.count / rowsPerPage
                    ).toString();
                    return (
                      <>
                        {`Página: ${page + 1}${`/${
                          totalPages === "0" ? "1" : totalPages
                        }`}`}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {`Total: ${rowsInfo.count}`}
                      </>
                    );
                  }}
                />
              </Scrollbar>
            </CardContent>
          </Card>
        </Container>
      </Page>
      {showError && <AlertMessage open={true} message="Senha incorreta!" />}
    </>
  );
}
